import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/src/app/welcome/products/page.tsx");
